import * as React from 'react';
import CustomViewsModal from './customViewModal/custom-views-modal';
import IconButtonTooltip from '../common/iconButtonTooltip';
import { IconButton } from '@material-ui/core';
import { CropOriginal } from '@material-ui/icons';
import { datadogRum } from '@datadog/browser-rum';

interface Props {
  viz: any;
  dashboardName: string;
  isInteractive: boolean;
  edge?: 'start' | 'end' | false;
}

/**
 * Render the Custom Views Button and associated Modal components
 */
const CustomViewsButton = ({ viz, dashboardName, isInteractive, edge }: Props) => {
  const [showModal, setShowModal] = React.useState<boolean>(false);
  const [currentViewName, setCurrentViewName] = React.useState<string>('Original');

  function handleClick() {
    datadogRum.addUserAction('views', {
      user_action_details: {
        type: 'tableau_toolbar',
        name: 'views',
        dashboard_name: dashboardName
      }
    });
    if (viz) {
      setShowModal(true);
    }
  }

  React.useEffect(() => {
    if (viz && isInteractive && viz.workbook) {
      setCurrentViewName(viz.workbook.name);
    }
  }, [viz, isInteractive]);

  return (
    <React.Fragment>
      <CustomViewsModal open={showModal} onClose={() => setShowModal(false)} viz={viz} isInteractive={isInteractive} />
      <IconButtonTooltip title={`View ${currentViewName}`}>
        <IconButton onClick={handleClick} edge={edge || false} size="small">
          <CropOriginal />
        </IconButton>
      </IconButtonTooltip>
    </React.Fragment>
  );
};

export default CustomViewsButton;
